import {
  RETRIEVE_INBOUND_POSTAL_OPERATOR_UNLOCODE_REQUEST,
  RETRIEVE_INBOUND_POSTAL_OPERATOR_UNLOCODE_SUCCESS,
  RETRIEVE_INBOUND_POSTAL_OPERATOR_UNLOCODE_FAILURE,
  ARRIVAL_UNLOCODE_CHECKED,
  ARRIVAL_POSTAL_OPERATOR_EXPANDED,
  SELECT_ALL_ARRIVAL_UNLOCODES,
  DESELECT_ALL_ARRIVAL_UNLOCODES,
} from './types/ArrivalPostalOperatorActionTypes';

export function retrieveInboundPostalOperatorsUnlocodeRequestActionCreator(
  payload,
  reportDefinition,
  arrivalCheckedUnlocodes,
) {
  return {
    type: RETRIEVE_INBOUND_POSTAL_OPERATOR_UNLOCODE_REQUEST,
    payload,
    reportDefinition,
    arrivalCheckedUnlocodes,
  };
}

export function retrieveInboundPostalOperatorsUnlocodeSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_INBOUND_POSTAL_OPERATOR_UNLOCODE_SUCCESS,
    payload,
  };
}

export function retrieveInboundPostalOperatorsUnlocodeFailureActionCreator(error) {
  return {
    type: RETRIEVE_INBOUND_POSTAL_OPERATOR_UNLOCODE_FAILURE,
    error,
  };
}

export function arrivalUnlocodeCheckedActionCreator(
  checkedUnlocodes,
  reportDefinition,
) {
  return {
    type: ARRIVAL_UNLOCODE_CHECKED,
    checkedUnlocodes,
    reportDefinition,
  };
}

export function onArrivalPostalOperatorExpanded(expandedPostalOperators) {
  return {
    type: ARRIVAL_POSTAL_OPERATOR_EXPANDED,
    expandedPostalOperators,
  };
}

export function onSelectAllArrivalUnlocodes(nodes) {
  return {
    type: SELECT_ALL_ARRIVAL_UNLOCODES,
    payload: {
      nodes,
    },
  };
}

export function onDeSelectAllArrivalUnlocodes() {
  return {
    type: DESELECT_ALL_ARRIVAL_UNLOCODES,
  };
}
